import { assetUrl } from '@/config/api';
import ArtworkViewer from './ArtworkViewer.jsx';

const CardPreviewModal = ({
  open,
  card,
  onClose,
  backgroundUrl,
  textStyle,
  emptyMessage,
  closeLabel,
}) => {
  if (!open) {
    return null;
  }

  const cardStyle = {
    ...(backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : {}),
    ...(textStyle || {}),
  };

  return (
    <div
      className="card-preview-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <button
        type="button"
        className="card-preview-close"
        onClick={onClose}
        aria-label={closeLabel}
      >
        ×
      </button>
      <div className="card-preview-shell" onClick={(event) => event.stopPropagation()}>
        {card?.imageUrl ? (
          <div className="card-preview-modal__content card-preview-modal__content--artwork">
            <ArtworkViewer
              src={card.imageUrl.startsWith('blob:') ? card.imageUrl : assetUrl(card.imageUrl)}
              alt={card.title || String(card.cellNumber)}
            />
          </div>
        ) : card ? (
          <div className="card-preview-modal__content">
            <div className="card-preview-modal__card" style={cardStyle}>
              <span className="deck-card-preview__cell">{card.cellNumber}</span>
              <div className="card-preview-modal__text">
                <h3 className="deck-card-preview__card-title">{card.title}</h3>
                <p className="deck-card-preview__card-text">
                  {card.text}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <p className="card-preview-modal__empty">{emptyMessage}</p>
        )}
      </div>
    </div>
  );
};

export default CardPreviewModal;
